export function shouldShowBigHoverAction(action: string, canDelete: boolean, canArchive: boolean, isInArchiveFolder: boolean, isInOutboxFolder: boolean): boolean | null {
    switch (action) {
        case "Delete":
            return canDelete;
        case "Archive":
            // Don't show archive big hover action in Archive and Outbox folders
            return !isInArchiveFolder && !isInOutboxFolder && canArchive;
    }
    return null;
}
